import { openWhatsApp } from "../../utils/whatsapp";

export default function CTABanner() {
  return (
    <div className="sm-cta-banner" id="cta">
      <div className="sm-cta-inner sm-reveal">
        <h2 className="sm-cta-h2">See what stock is blocking your cash.</h2>
        <p className="sm-cta-sub">
          Upload your sales and inventory data and get a full action report —
          what to clear, what to stop buying, and how much cash you can free up.
        </p>
        <button onClick={() => openWhatsApp()} className="sm-btn-light">
          Get Free Inventory Audit →
        </button>
        <p
          style={{
            marginTop: 16,
            fontSize: 13,
            color: "rgba(232,240,235,.45)",
          }}
        >
          No credit card. No POS required. Just a CSV or Excel file.
        </p>
      </div>
    </div>
  );
}